<template>
	<inertia-head title="Payout" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 v-if="$page.props.user.is_super_sponsor==1" class="badge bg-warning text-white fs-lg">SUPER AFFILIATE</h1>
					<h1 class="fw-bold text-white mb-2">Payout</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Here you can check your available commissions and request for payout
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content mt-5">
		<div class="row">
			<div class="col-6 col-xl-6 mb-3">
				<a
					class="block block-rounded block-link-pop text-end mb-1"
					href="javascript:void(0)"
				>
					<div
						class="block-content block-content-full d-sm-flex justify-content-between align-items-center border-black-op-b border-3"
					>
						<div class="d-none d-sm-block">
							<i class="fa fa-sitemap fa-2x text-primary-light"></i>
						</div>
						<div class="text-end">
							<div class="fs-3 fw-semibold">{{moneyFormatter().format(commInfo.total_comm)}}</div>
							<div class="fs-sm fw-semibold text-uppercase text-muted">
								Total Affiliate Commission
							</div>
							<small class="text-muted fs-xs">
								New System: {{moneyFormatter().format(commInfo.total_comm_new)}} | Old System: {{moneyFormatter().format(commInfo.total_comm_old)}}
							</small>
						</div>
					</div>
				</a>
			</div>
			<div class="col-6 col-xl-6 mb-3">
				<a
					class="block block-rounded block-link-pop text-end mb-1"
					href="javascript:void(0)"
				>
					<div
						class="block-content block-content-full d-sm-flex justify-content-between align-items-center border-black-op-b border-3"
					>
						<div class="d-none d-sm-block">
							<i class="fa fa-coins fa-2x text-earth-light"></i>
						</div>
						<div class="text-end">
							<div class="fs-3 fw-semibold">{{moneyFormatter().format(commInfo.total_withheld)}}</div>
							<div class="fs-sm fw-semibold text-uppercase text-muted">
								Total Witheld
							</div>
							<small class="text-muted fs-xs">
								We honor 30 days refund policy
							</small>
						</div>
					</div>
				</a>
			</div>
			<div class="col-6 col-xl-6 mb-3">
				<a
					class="block block-rounded block-link-pop text-end mb-1"
					href="javascript:void(0)"
				>
					<div
						class="block-content block-content-full d-sm-flex justify-content-between align-items-center border-black-op-b border-3"
					>
						<div class="d-none d-sm-block">
							<i class="fa fa-wallet fa-2x text-elegance-light"></i>
						</div>
						<div class="text-end">
							<div class="fs-3 fw-semibold">{{moneyFormatter().format(commInfo.total_encashed)}}</div>
							<div class="fs-sm fw-semibold text-uppercase text-muted">
								Total Encashed
							</div>
							<small class="text-muted fs-xs">Commission Transferred</small>
						</div>
					</div>
				</a>
			</div>
			<div class="col-6 col-xl-6 mb-3">
				<a
					class="block block-rounded block-link-pop text-end mb-1"
					href="javascript:void(0)"
				>
					<div
						class="block-content block-content-full d-sm-flex justify-content-between align-items-center border-black-op-b border-3"
					>
						<div class="d-none d-sm-block">
							<i class="fa fa-money-check fa-2x text-corporate-light"></i>
						</div>
						<div class="text-end">
							<div class="fs-3 fw-semibold">{{moneyFormatter().format(commInfo.total_available)}}</div>
							<div class="fs-sm fw-semibold text-uppercase text-muted">
								Available
							</div>
							<small class="text-muted fs-xs">
								Available To Request Payout
							</small>
						</div>
					</div>
				</a>
			</div>
			<!-- END Row #1 -->
		</div>
		<div class="row mt-5">
			<div class="col-lg-12">
				<div class="block block-rounded">
					<form>
						<div class="block-content">
							<h3 class="border-bottom pb-3 mb-3">Encashment Info</h3>
							<h5 class="mb-5">You Need to have a minimun of {{moneyFormatter().format(payoutSetting.minimum_withdrawal)}} before you can request for payout.</h5>
							<div class="form-floating mb-4">
								<select v-model="formPayout.method" id="method" :disabled="commInfo.enabled_encash==false" class="form-select">
									<option value="">Select</option>
									<option v-for="opt in payoutOptions" :value="opt[0].type">{{opt[0].type}}</option>
								</select>
								<label class="form-label"><span class="text-danger">*</span>Select Type</label>
								<div v-if="formPayout.errors.method" class="show-error">
									<i class="fa fa-exclamation-circle"></i>
									{{ formPayout.errors.method }}
								</div>
							</div>
							<div class="form-floating mb-4">
								<select v-model="formPayout.bank_name" id="bank_name" :disabled="commInfo.enabled_encash==false" class="form-select">
									<option value="">Select</option>
									<option v-if="formPayout.method" v-for="popt in payoutOptions[formPayout.method][0].banks" :value="popt.mop_code+'|'+popt.description">{{popt.description}}</option>
								</select>
								<label class="form-label"><span class="text-danger">*</span>Select Mode</label>
								<div v-if="formPayout.errors.bank_name" class="show-error">
									<i class="fa fa-exclamation-circle"></i>
									{{ formPayout.errors.bank_name }}
								</div>
							</div>
							<div class="form-floating mb-4">
								<input type="text" v-model="formPayout.account_fname" id="account_fname" name="account_fname" :disabled="commInfo.enabled_encash==false" class="form-control">
								<label class="form-label"><span class="text-danger">*</span>First Name</label>
								<div v-if="formPayout.errors.account_fname" class="show-error">
									<i class="fa fa-exclamation-circle"></i>
									{{ formPayout.errors.account_fname }}
								</div>
							</div>
							<div class="form-floating mb-4">
								<input type="text" v-model="formPayout.account_mname" id="account_mname" name="account_mname" :disabled="commInfo.enabled_encash==false" class="form-control">
								<label class="form-label"><span class="text-danger">*</span>Middle Name</label>
								<div v-if="formPayout.errors.account_mname" class="show-error">
									<i class="fa fa-exclamation-circle"></i>
									{{ formPayout.errors.account_mname }}
								</div>
							</div>
							<div class="form-floating mb-4">
								<input type="text" v-model="formPayout.account_lname" id="account_lname" name="account_lname" :disabled="commInfo.enabled_encash==false" class="form-control">
								<label class="form-label"><span class="text-danger">*</span>Last Name</label>
								<div v-if="formPayout.errors.account_lname" class="show-error">
									<i class="fa fa-exclamation-circle"></i>
									{{ formPayout.errors.account_lname }}
								</div>
							</div>
							<div class="form-floating mb-4">
								<input type="text" v-model="formPayout.account_number" id="account_number" name="account_number" :disabled="commInfo.enabled_encash==false" class="form-control">
								<label class="form-label"><span class="text-danger">*</span>Account Number</label>
								<div v-if="formPayout.errors.account_number" class="show-error">
									<i class="fa fa-exclamation-circle"></i>
									{{ formPayout.errors.account_number }}
								</div>
							</div>
							<div class="form-floating mb-4">
								<input type="text" v-model="formPayout.email" id="email" name="email" :disabled="commInfo.enabled_encash==false" class="form-control">
								<label class="form-label"><span class="text-danger">*</span>Account Email</label>
								<div v-if="formPayout.errors.email" class="show-error">
									<i class="fa fa-exclamation-circle"></i>
									{{ formPayout.errors.email }}
								</div>
							</div>
							<div class="form-floating mb-4">
								<input type="text" v-model="formPayout.mobile_number" id="mobile_number" name="mobile_number" :disabled="commInfo.enabled_encash==false" class="form-control">
								<label class="form-label"><span class="text-danger">*</span>Mobile Number</label>
								<div v-if="formPayout.errors.mobile_number" class="show-error">
									<i class="fa fa-exclamation-circle"></i>
									{{ formPayout.errors.mobile_number }}
								</div>
							</div>
							<div class="form-floating mb-4">
								<input type="text" v-model="formPayout.tin_number" id="tin_number" name="tin_number" :disabled="commInfo.enabled_encash==false" class="form-control">
								<label class="form-label"><span class="text-danger">*</span>TIN Number</label>
								<div v-if="formPayout.errors.tin_number" class="show-error">
									<i class="fa fa-exclamation-circle"></i>
									{{ formPayout.errors.tin_number }}
								</div>
							</div>
							<div class="form-floating mb-4">
								<div class="form-control">{{moneyFormatter().format(commInfo.total_available)}}</div>
								<label class="form-label">Amount to Encashed</label>
							</div>
						</div>
						<div v-if="commInfo.enabled_encash && isOpsRequest>0" class="block-content block-content-full">
							<div class="text-center">
								<button type="button" @click="requestWithdraw" class="btn btn-success btn-lg" :disabled="formPayout.processing || (formPayout.bank_name=='GCSH|Globe GCash' && commInfo.total_available>50000)">
									<span v-if="!formPayout.processing">Withdraw</span>
									<span v-else>
										<div class="spinner-border spinner-border-sm text-dark" role="status" >
											<span class="sr-only mr-1">Please wait...</span>
										</div>
										<span class="mx-2">Please wait...</span>
									</span>
								</button>
							</div>
						</div>
						<div v-if="isOpsRequest==0" class="block-content block-content-full">
							<p class="h4 text-center">Please contact our TRC Support</p>
						</div>
					</form>
				</div>
			</div>
		</div>
		<div class="row mt-5">
			<div class="col-lg-12">
				<div class="block block-rounded">
					<div class="block-content block-content-full">
						<div class="table-responsive">
							<table class="table table-hover">
								<thead>
									<tr>
										<th>Date</th>
										<th>Trans#</th>
										<th>Request</th>
										<th>Tax</th>
										<th>PF</th>
										<th>Total</th>
										<th>Status</th>
										<th>Ref#</th>
										<th>Remarks</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(request,r_index) in requestPayoutRes">
										<td>{{request.trans_date}}</td>
										<td>{{request.trans_num}}</td>
										<td>{{request.qualified}}</td>
										<td>{{request.tax}}</td>
										<td>{{request.pf}}</td>
										<td>{{request.total}}</td>
										<td>{{request.status}}</td>
										<td>{{request.dp_refno}}</td>
										<td>{{request.remarks}}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted,ref, inject } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import AuthLayout from '../../../Layouts/AuthLayout';
import { useForm } from '@inertiajs/inertia-vue3';
import { createToaster } from '@meforma/vue-toaster';

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	layout: AuthLayout,
	inject: ['moneyFormatter'],
	props: {
		app 			: Object,
		user 			: Object,
		errors 			: Object,
		payoutOptions 	: Object,
		payoutSetting 	: Object,
		commInfo 		: Object,
		memberInfo 		: Object,
		isOpsRequest 	: Number,
		requestPayoutRes: Object,
		api_response 	: Object
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const toast = createToaster();

		const formPayout = useForm({
							method 			: '',
							bank_name 		: '',
							account_fname 	: props.memberInfo.fname,
							account_mname 	: props.memberInfo.mname,
							account_lname 	: props.memberInfo.lname,
							account_number 	: '',
							email 			: props.memberInfo.email,
							mobile_number 	: (props.memberInfo.mobile).replace("+",""),
							tin_number 		: props.memberInfo.tin,
							qualified 		: props.commInfo.total_available,
							tax 			: props.payoutSetting.tax_percentage,
							pf 				: props.payoutSetting.processing_fee
						});

		const requestWithdraw = ()=>{
			formPayout.errors = {};
			formPayout.post(route("member.affiliate-program.post.request-withdraw"),{
							preserveState: true,
							preserveScroll: true,
							only:['commInfo,requestPayoutRes,api_response,errors'],
							onSuccess: (res)=>{
								if(props.api_response.result=="success")
								{
									toast.show("Payout request was successfully submitted", { type: props.api_response.result});
								}else
								{
									toast.show("Failed to submit the payout request form", { type: "danger"});
								}
							},
							onError: (errors)=>{

								for (const [key, value] of Object.entries(formPayout)) {

									if(formPayout.errors[key]){
										var  el = document.getElementById(key);

										el.focus();	

										break;
									}

								}
							}
						});

		}

		return{
			toast,
			formPayout,
			requestWithdraw
		}
	},
}
</script>
